import { useRef } from 'react';
import { useToast as useChakraToast, AlertIcon, AlertDescription, AlertProps } from '@chakra-ui/react';
import { Toast } from 'components/UI';

type ToastProps = {
  message: string;
  duration?: number;
  isClosable?: boolean;
  href?: string;
  position?: 'top' | 'top-right' | 'top-left' | 'bottom' | 'bottom-right' | 'bottom-left';
} & AlertProps;

const useToast = () => {
  const toast = useChakraToast();
  const toastIdRef = useRef<string | number | undefined>();

  const handleClose = () => {
    if (toastIdRef.current) {
      toast.close(toastIdRef.current);
    }
  };

  const handleCloseAll = () => {
    toast.closeAll();
  };

  const handleOpen = ({ message, position, duration, isClosable, ...props }: ToastProps) => {
    toastIdRef.current = toast({
      position: position ?? 'bottom-right',
      duration: duration ?? 5000,
      isClosable,
      render: () => (
        <Toast status="success" borderRadius={4} variant="solid" {...props}>
          <AlertIcon />
          <AlertDescription maxWidth="sm">{message}</AlertDescription>
        </Toast>
      ),
    });
  };

  return [handleOpen, handleClose, { hideAllToasts: handleCloseAll }] as const;
};

export default useToast;
